/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Logo from '../../components/logo';
import NavigationItem from '../../components/home/navigation-item';
import Chevron from '../../components/general/navigation-chevron';

const Button = styled(NavigationItem)`
	display: block;
	max-width: 150px;
	margin: auto;
`;

const NavigationChevron = styled(Chevron)`
	position: absolute;
	top: 9px;
	right: 12px;
`;

class HomeLogo extends React.Component {
    render() {
        return (
            <div>
                <Logo/>

                <Button to="/dashboard/shop">
                    Monteur

                    <NavigationChevron/>
                </Button>
            </div>
        );
    }
}

export default HomeLogo;



// WEBPACK FOOTER //
// ./src/components/home/logo.js